import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import {
  getDefaultLocale,
  getFlattenedMessages,
  resolveLocale,
  isRTLLocale,
} from '../../translations/react-intl-setup';

interface IntlProviderWrapperProps {
  children: React.ReactNode;
}

const IntlProviderWrapper: React.FC<IntlProviderWrapperProps> = ({
  children,
}) => {
  const [locale, setLocale] = useState(getDefaultLocale());
  const [messages, setMessages] = useState(
    getFlattenedMessages(getDefaultLocale())
  );

  const currentLocale = useSelector((state: any) => {
    try {
      return state?.session?.locale || getDefaultLocale();
    } catch (e) {
      return getDefaultLocale();
    }
  });

  useEffect(() => {
    const newLocale = resolveLocale(currentLocale);

    if (newLocale !== locale) {
      setLocale(newLocale);
      setMessages(getFlattenedMessages(newLocale));

      const isRTL = isRTLLocale(newLocale);
      document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
      document.documentElement.lang = newLocale;
    }
  }, [currentLocale, locale]);

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      defaultLocale={getDefaultLocale()}
      onError={(error) => {
        console.warn('React-intl error:', error);
      }}
    >
      {children}
    </IntlProvider>
  );
};

export default IntlProviderWrapper;
